import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import SideMenu from "components/admin/layout/SideMenu";

const DlUnitList: React.FC = () => {
  const [query, setQuery] = useState("");

  const handleSearch = () => {
    console.log("Pretraga:", query);
  };

  return (
    <Page>
      <FullWidth>
        <div className="row">
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12">
            <SideMenu />
          </div>

          <div
            className="col-xl-10 col-lg-9 col-md-9 col-sm-12 offset-xl-1 offset-lg-1 offset-md-1"
            style={{ marginLeft: "15%", marginTop: "-10%" }}
          >
            <Content>
              <ContentInner>
                <Wrapper>
                  {/* SEARCH FORM */}
                  <Form>
                    <FormGroup>
                      <Label htmlFor="formBasicSearch">Pretraživanje</Label>
                      <Input
                        id="formBasicSearch"
                        type="text"
                        placeholder="ključna reč"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        style={{ width: "20%" }}
                      />
                    </FormGroup>

                    <PrimaryButton type="button" onClick={handleSearch}>
                      OK
                    </PrimaryButton>
                  </Form>

                  {/* NAV */}
                  <Nav>
                    <NavItem>&lt;&lt;</NavItem>
                    <NavItem>&lt;</NavItem>
                    <NavItem>&gt;</NavItem>
                    <NavItem>&gt;&gt;</NavItem>

                    <NavItem marginLeft="2%">1</NavItem>
                    <NavItem marginLeft="0.5%">/</NavItem>
                    <NavItem marginLeft="0.5%">1889</NavItem>
                  </Nav>

                  {/* UPLOAD */}
                  <UploadSection>
                    <SectionTitle>Unos zapisa preko fajla</SectionTitle>
                    <UploadWrapper>
                      <FileInput type="file" />
                    </UploadWrapper>
                  </UploadSection>

                  {/* NEW */}
                  <NewRecordWrapper>
                    <StyledLink to="/admin-dashboard/dl-unit-edit">
                      novo
                    </StyledLink>
                  </NewRecordWrapper>

                  {/* ITEM */}
                  <ItemBlock>
                    <InlineLinks>
                      <Linkspan marginLeft="0%">polja</Linkspan>
                      <Linkspan marginLeft="2%">pdf</Linkspan>
                    </InlineLinks>

                    <Delete>obriši</Delete>
                  </ItemBlock>
                </Wrapper>
              </ContentInner>
            </Content>
          </div>
        </div>
      </FullWidth>
    </Page>
  );
};

export default DlUnitList;

const Page = styled.div`
  min-height: 100vh;
`;

const FullWidth = styled.div`
  width: 100%;
`;

const Content = styled.div``;

const ContentInner = styled.div`
  width: 90%;
`;

const Wrapper = styled.div`
  width: 100%;
`;

const Form = styled.form`
  margin-bottom: 1rem;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 0.25rem;
`;

const Input = styled.input`
  padding: 0.5rem;
`;

const PrimaryButton = styled.button`
  margin-top: 0.5rem;
`;

const Nav = styled.div`
  display: flex;
  margin-top: 1rem;
`;

const NavItem = styled.span<{ marginLeft?: string }>`
  margin-left: ${({ marginLeft }) => marginLeft || "0.5%"};
  cursor: pointer;
`;

const UploadSection = styled.div`
  margin-top: 4rem;
`;

const SectionTitle = styled.div`
  font-weight: 500;
`;

const UploadWrapper = styled.div`
  margin-top: 1rem;
`;

const FileInput = styled.input``;

const NewRecordWrapper = styled.div`
  margin-top: 1rem;
`;

const StyledLink = styled(Link)`
  color: #0d6efd;
`;

const ItemBlock = styled.div`
  margin-top: 1rem;
`;

const InlineLinks = styled.div`
  display: inline;
`;

const Linkspan = styled.span<{ marginLeft?: string }>`
  margin-left: ${({ marginLeft }) => marginLeft || "0%"};
`;

const Delete = styled.span`
  margin-left: 5%;
  cursor: pointer;
  color: darkgrey;
`;
